"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyContractsModule = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var fitpos_api_1 = require("../../../api/fitpos-api");
var mappings_const_1 = require("../const/mappings.const");
var data_processing_service_1 = require("../services/data-processing.service");
var MyContractsModule = /** @class */ (function () {
    function MyContractsModule() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        this.dataProcessing = object_service_1.ObjectService.getInstance(data_processing_service_1.DataProcessing);
        this.emptyMessage = 'There are no contracts for this user';
    }
    MyContractsModule.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_1, refObjectId, _i, _b, contract;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 1:
                        _a.contracts = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _c.sent();
                        (0, generator_const_1._ShowErrorMessage)(mappings_const_1._Messages.GetError);
                        // disable inputs etc.?
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3:
                        refObjectId = '#' + this.config.get.fitpos.refObjectMyContracts;
                        if (this.contracts.length) {
                            moduleDiv.setAttribute(MyContractsModule.selected, this.contracts[0].id.toString());
                            // TODO styling
                        }
                        else {
                            (0, cash_dom_1.default)(refObjectId).css('display', 'none');
                            (0, cash_dom_1.default)(refObjectId).parent().append(this.emptyMessage);
                        }
                        for (_i = 0, _b = this.contracts; _i < _b.length; _i++) {
                            contract = _b[_i];
                            // const rate = offerings.find(offering => offering.name === contract.rateName);
                            // //needed for output:
                            // contract.description = rate.description;
                            // contract.subDescription = rate.subDescription;
                            // const clone = this.helper.createClonesForRefObjectId(
                            //   [{ key: 'data-id', value: contract.id.toString() }],
                            //   refObjectId
                            // ); // TODO restrict to inside of moduleDiv
                            // if (clone) {
                            //   this.dataProcessing.fillDataGet(clone[0], contract);
                            // }
                            // $(refObjectId).parent().append(clone);
                            // clone.on('click', (event) => {
                            //   if (this.contracts.length > 1) {
                            //     //if user has more than one contract we have to choose which one has to be used to perform an action
                            //     if (this.selectedContract?.id === contract.id) {
                            //       const oldContractDiv = moduleDiv.querySelector(
                            //         '[data-id="' + this.selectedContract?.id + '"]'
                            //       ) as HTMLDivElement;
                            //       this.selectedContract = undefined;
                            //       oldContractDiv.style.border = 'none';
                            //     } else {
                            //       const oldContractDiv = moduleDiv.querySelector(
                            //         '[data-id="' + this.selectedContract?.id + '"]'
                            //       ) as HTMLDivElement;
                            //       if (this.selectedContract?.id && oldContractDiv) {
                            //         oldContractDiv.style.border = 'none';
                            //       }
                            //       const newContractDiv = moduleDiv.querySelector(
                            //         '[data-id="' + contract.id + '"]'
                            //       ) as HTMLDivElement;
                            //       console.log(event, 'EVENT');
                            //       this.selectedContract = contract;
                            //       newContractDiv.style.border = 'solid';
                            //       newContractDiv.style.borderColor = 'var(--primary)';
                            //     }
                            //   }
                            moduleDiv.setAttribute(MyContractsModule.selected, contract.id.toString());
                            // $(moduleDiv).attr(MyContractsModule.selected, contracts[0].id.toString());
                            // }); // TODO styling
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MyContractsModule.selected = 'data-selected';
    return MyContractsModule;
}());
exports.MyContractsModule = MyContractsModule;
